module.exports = __webpack_public_path__ + "img/ps-33.2406e8df.jpg";